<template>
  <div class="min-h-screen flex flex-col">
    <RenderTemplateHeader />

    <main class="flex-1 flex">
      <div
        class="flex flex-1 flex-col px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24 w-full max-w-sm lg:max-w-md box-content mx-auto"
      >
        <div class="lg:px-5 w-full">
          <div class="flex-1">
            <MenuBreadcrumb />
            <slot />
          </div>
        </div>
      </div>
      <div class="relative hidden w-0 flex-1 lg:block bg-gray-900">
        <div v-if="image" class="absolute inset-0">
          <TLazyimg v-if="image" v-bind="image" />

          <div class="absolute inset-0 bg-black/30 mix-blend-multiply" />
        </div>
        <div class="z-10 absolute h-full w-full">
          <div class="flex h-full py-12 px-20 xl:px-24">
            <div class="m-auto w-full max-w-sm lg:max-w-lg lg:px-3 mt-[20vh]">
              <aside class="flex-1">
                <slot name="aside"></slot>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import type { TLazyimg_Props } from '~/modules/design-system/components/t-lazyimg/constants/types'
import { useTemplateDataComposable } from '~/modules/template/composables/useTemplateDataComposable'

const { t } = useI18n({})

await useTemplateDataComposable({
  template: 'split',
})

const route = useRoute()

let image: TLazyimg_Props | null = null

if (route.meta.splitImageUrl) {
  image = {
    sources: {
      url: route.meta.splitImageUrl as string,
    },
    alt: '',
    classesImg: 'absolute inset-0 h-full w-full object-cover',
  }

  if (route.meta.splitImageAlt) {
    image.alt = t(route.meta.splitImageAlt as string)
  }
}
</script>
